import { render } from "./ConfirmationCommande.vue?vue&type=template&id=e5697238&scoped=true&ts=true"
import script from "./ConfirmationCommande.vue?vue&type=script&lang=ts"
export * from "./ConfirmationCommande.vue?vue&type=script&lang=ts"

import "./ConfirmationCommande.vue?vue&type=style&index=0&id=e5697238&lang=scss&scoped=true"

import exportComponent from "E:\\User\\Documents\\GitHub\\PortailMalecites\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5697238"]])

export default __exports__